// extracted by mini-css-extract-plugin
export var bodySections = "_dp-8";
export var gray = "_dp-7";
export var green = "_dp-4";
export var iconContainer = "_dp-9";
export var iconWidgetContainer = "_dp-1";
export var phoneIcon = "_dp-2";
export var red = "_dp-5";
export var statusDot = "_dp-3";
export var widgetContainer = "_dp-0";
export var yellow = "_dp-6";